import { StoreRootState } from "#/store/types";

const getEventSystem = (state: StoreRootState) => state.eventSystem;

export default { getEventSystem };
